<template>
  <div>
    <b-form v-if="value.callOpt">
      <b-form-group class="sub-label " label="Content Type">
        <b-form-radio-group id="radios2" v-model="value.callOpt.contentType" stacked name="radioSubComponent" @input="updateData">
          <b-form-radio value="application/x-www-form-urlencoded">application/x-www-form-urlencoded</b-form-radio>
          <b-form-radio value="multipart/form-data">multipart/form-data</b-form-radio>
          <b-form-radio value="text/plain">text/plain</b-form-radio>
          <b-form-radio value="custom" class="w-100 custom-content-type">
            <b-input v-model="customContentType"  class="customContentType" placeholder="custom type" @focus.native="selectCustom"></b-input>
          </b-form-radio>
        </b-form-radio-group>
      </b-form-group>
      <b-form-group label="Connect Using" class="mode-group sub-label" @input="updateData">
        <b-form-radio-group id="btnradios2" buttons button-variant="outline-custom" v-model="value.connectURL" :options="options" name="radioBtnOutline" />
      </b-form-group>
      <b-form-group class="sub-label mt-3"  label="SSL Version">
        <b-form-select v-model="value.callOpt.SSLVersion" :options="TLSOptions" class="mb-3" @input="updateData" />
      </b-form-group>
    </b-form>
  </div>
</template>

<script>
export default {
  name: 'advanced',
  props: ['value'],
  mounted() {
    if (
      this.value &&
      (this.value.callOpt == null || this.value.callOpt.contentType == '')
    ) {
      this.value.callOpt = {
        contentType: 'application/x-www-form-urlencoded',
        SSLVersion: '0'
      };
    }
  },
  data() {
    return {
      selected: 'application/x-www-form-urlencoded',
      options: [
        { text: 'Default', value: 'default' },
        { text: 'Site URL', value: 'siteURL' },
        { text: 'WP Admin URL', value: 'adminURL' }
      ],
      customContentType: '',
      TLSOptions: [
        {
          text: 'Auto',
          value: '0'
        },
        {
          text: 'TLS v1.x',
          value: '1'
        },
        {
          text: 'SSL v2',
          value: '2'
        },
        {
          text: 'SSL v3',
          value: '3'
        },
        {
          text: 'TLS v1.0',
          value: '4'
        },
        {
          text: 'TLS v1.1',
          value: '5'
        }
      ]
    };
  },
  watch: {
    customContentType(newValue) {
      this.value.callOpt.contentType = newValue;
    }
  },
  methods: {
    selectCustom() {
      this.value.callOpt.contentType = 'custom';
    },
    updateData() {
      this.$emit('input', this.value);
    }
  }
};
</script>

<style>
</style>
